import { Route } from "react-router-dom";
import { MonthlyCalendarPage, MonthlyUserProjectsCalendarPage, WeeklyCalendarPage, WeeklyUserProjectsCalendarPage } from "../Calendar/Calendar";

export const CALENDAR_ROUTES = [
    <Route key="calendar-monthly" path="/calendar/monthly" element={<MonthlyCalendarPage />} />,
    <Route key="calendar-weekly" path="/calendar/weekly" element={<WeeklyCalendarPage />} />,
    <Route key="calendar-monthly-user" path="/calendar/monthly/user" element={<MonthlyUserProjectsCalendarPage />} />,
    <Route key="calendar-weekly-user" path="/calendar/weekly/user" element={<WeeklyUserProjectsCalendarPage />} />
];
